// @flow

import * as React from 'react'
import { Button } from 'semantic-ui-react'

import authenticatedRequest from '../store/authenticated-request'
import type { $AxiosXHR } from 'axios'

type Props = {|
  label: string,
  downloadUrl: string,
  downloadParams: Object,
  disabled: boolean,
  onError: Function,
|}

type State = {|
  isPending: boolean,
|}

class FileDownloaderButton extends React.Component<Props, State> {
  static defaultProps = {
    onError: () => {},
  }
  state = {
    isPending: false,
  }

  startDownload = async () => {
    try {
      if (this.state.isPending) return
      this.setState({ isPending: true })
      let response: $AxiosXHR<*> = await authenticatedRequest.get(this.props.downloadUrl, {
        params: this.props.downloadParams,
        responseType: 'arraybuffer',
      })

      if (!response.headers) throw new Error('No headers present on response object')
      let fname = response.headers['content-disposition'].match(/^.*"(.*)"/)[1]
      if (!response.headers) throw new Error('No headers present on response object')
      let type = response.headers['content-type']
      let blob = new Blob([response.data], { type })
      let url = URL.createObjectURL(blob)

      if (window.navigator.msSaveOrOpenBlob) {
        //IE11 support
        window.navigator.msSaveOrOpenBlob(blob, fname)
      } else {
        let element = document.createElement('a')
        if (!document.body) throw new Error('No Document Body')
        document.body.appendChild(element)
        element.setAttribute('href', url)
        element.setAttribute('download', fname)
        element.style.display = ''
        element.click()

        if (!document.body) throw new Error('No Document Body')
        document.body.removeChild(element)
        URL.revokeObjectURL(url)
      }
      this.setState({ isPending: false })
    } catch (err) {
      this.setState({ isPending: false })
      this.props.onError()
      console.log('Errore di download', err)
    }
  }

  render() {
    return (
      <Button
        style={{ minWidth: '20ex' }}
        icon="download"
        content={this.props.label}
        labelPosition="left"
        size="small"
        loading={this.state.isPending}
        color="orange"
        disabled={this.props.disabled}
        onClick={this.startDownload}
      />
    )
  }
}

export default FileDownloaderButton



// WEBPACK FOOTER //
// ./src/systemwide/file-downloader-button.js